// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"f0eca026","164":"80b831cd","213":"7f732e06","300":"59cf367f","356":"bc604d40","368":"54677df2","422":"1de99a42","455":"94f36d5a","529":"e091f6da","536":"ee061464","550":"ac31b2a1","601":"27522af0","627":"fce5a444","761":"02d08810","778":"af92256c","972":"b5264ad0"}[chunkId] + ".chunk.js";
};